module.exports = __webpack_public_path__ + "f2ec4d6b8b7d9b812a920dcdafdcd516.jpg";